import Vue from "vue";
import Lang from "lang.js";
import VueRouter from "vue-router";
import videoRoutes from "./routes/videos";
import {ZiggyVue} from "../../vendor/tightenco/ziggy/dist/vue.m";


Vue.component(
    "deposits-component",
    require("./components/deposits/Deposits.vue").default
);
Vue.component(
    "province-school-component",
    require("./components/ProvinceSchoolComponent.vue").default
);
Vue.component(
    "form-data-component",
    require("./components/FormData.vue").default
);
Vue.component(
    "schoolsearch-component",
    require("./components/SchoolSearch.vue").default
);
Vue.component("contact-form", require("./components/ContactForm.vue").default);
Vue.component('contact-form-new', require('./components/ContactFormNew.vue').default);
Vue.component(
    "jobs-component",
    require("./components/JobsComponent.vue").default
);
Vue.component("join-us", require("./components/JoinUs.vue").default);
Vue.component(
    "matriculation-form",
    require("./components/MatriculationForm.vue").default
);
Vue.component(
    "facebook-api-component",
    require("./components/FacebookApiComponent.vue").default
);
Vue.component(
    "banner-header",
    require("./components/BannerHeader.vue").default
);
Vue.component("home-map", require("./components/Map/MapWrapper.vue").default);
Vue.component('catalog-blog', require('./components/blog/CatalogBlog.vue').default);

// Popup
Vue.component('popup', require('./components/school/Popup.vue').default);
Vue.component('integrated-button-popup', require('./components/school/IntegratedButtonPopup.vue').default);

// Map Components
Vue.component("school-box", require("./components/Map/SchoolBox.vue").default);
Vue.component("base-map", require("./components/Map/BaseMap.vue").default);
Vue.component("school-info-popup", require("./components/Map/SchoolInfoPopup.vue").default);

Vue.component('side-menu', require('./components/layouts/SideMenu.vue').default);
Vue.component('side-menu-content', require('./components/layouts/SideMenuContent.vue').default);
Vue.component('locale-selector', require('./components/aula/common/LocaleSelector.vue').default);
Vue.component('balloons', require('./components/Balloons.vue').default);


import { store } from "./store";
import Vuetify, { VApp, VSelect, VTextField, VTextarea, VForm, VBtn, VDialog, VDatePicker, VSpacer, VMenu, VSnackbar, VIcon, VFileInput, VCard, VSkeletonLoader } from "vuetify/lib";
import { Ripple } from "vuetify/lib/directives";

let router;
if (!document.querySelector("#wizard-page")) {
    Vue.use(VueRouter);
    router = new VueRouter({
        mode: "history",
        base: process.env.BASE_URL,
        routes: videoRoutes
    });
}

Vue.use(Vuetify, {
    components: {
        VApp,
        VSelect,
        VTextField,
        VTextarea,
        VForm,
        VBtn,
        VDialog,
        VDatePicker,
        VSpacer,
        VMenu,
        VSnackbar,
        VIcon,
        VFileInput,
        VCard,
        VSkeletonLoader
    },
    directives: {
        Ripple
    }
});

Vue.use(ZiggyVue);

window.vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#0fc0cc",
                secondary: "#ffffff",
                accent: "#0fc0cc",
                error: "#fff",
                info: "#f44336",
                success: "#4CAF50",
                warning: "#FFC107",
                fail: "#F44336"
            },
            dark: {
                primary: "#0fc0cc",
                secondary: "#000000",
                accent: "#0fc0cc",
                error: "#f44336",
                info: "#f44336",
                success: "#4CAF50",
                warning: "#FFC107",
                fail: "#F44336"
            }
        }
    },
    icons: {
        iconfont: "mdiSvg"
    }
});

// Set translations
const messages = Object.entries(window.messages[window.appLocale]).reduce(
    (agg, [key, value]) => {
        agg[`${window.appLocale}.${key}`] = value;
        return agg;
    },
    {}
);
Vue.prototype.$trans = new Lang({
    messages,
    locale: window.appLocale
});

if (!document.querySelector("#wizard-page")) {
    new Vue({
        el: "#app",
        store,
        vuetify,
        router,
        data() {
            return {
              isActive: false
            };
        },
        methods: {
            closeMenu(){
                this.isActive = false
            },
        }
    });

    store.dispatch("loadResources");
}

// import SchoolsComponent from './components/SchoolsComponent';

// var instance = new Vue({
//     el: '#schools',
//     store,
//     components: {
//         SchoolsComponent
//     },
// })
